<ng-template #taskTemplate let-task let-idx="idx" let-date="date" let-headers="show_headers">
  <div class="heading" *ngIf="headers && task.showHeader">
    <div class="overdue h4" *ngIf="date && now_time > date">
      Overdue
    </div>
    <div class="h4" *ngIf="date && now_time <= date">
      {{ date | date: "EEEE" }}
      <span>{{ date | date: "d MMM y" }}</span>
    </div>
    <div class="no_date h4" *ngIf="!date">No date</div>
  </div>
  <div class="body" [ngClass]="{sidebar: placement === 'sidebar' }">
    <div class="unseen_bar" [ngClass]="{ readonly: readonly }">
      <div class="color_bar" (click)="toggleUnseen(task)"></div>
      <div class="platter narrow handle">
        <div class="plate handle"></div>
        <icon class="handle" matIcon="drag_indicator"></icon>
      </div>
    </div>
    <!-- <icon (click)="readonly ? null : taskService.updateComplete(task)" class="task-check-circle" [icon]="task.completed ?  'task_complete_24px' : 'task_incomplete_24px'"></icon> -->
    <div class="task_content" (click)="openTaskDialog(task, $event)">
      <div class="task_area">
        <div class="flag_area no-popup" [ngClass]="{ readonly: readonly }">
          <icon class="flag_static" *ngIf="task.flag" icon="flag_on_24px"></icon>
          <icon class="flag no-popup" (click)="taskService.updateFlag(task)" *ngIf="task.flag" icon="flag_on_24px"></icon>
          <icon class="outline no-popup" (click)="taskService.updateFlag(task)" *ngIf="!task.flag" icon="flag_off_24px"></icon>
        </div>
        <div class="task_details">
          <div class="head">
            <div class="program">
              <div *ngIf="task.program && programService.program_legend[task.program] !== undefined">
                {{ programService.programs[programService.program_legend[task.program]]?.title }}
              </div>
            </div>
            <div class="name" [ngClass]="{ completed: task.status === 'complete' }">
              <joi-input [(model)]="task.name" (joiChange)="taskService.updateTask(task.id, { name: task.name })" [disabled]="readonly" type="textarea" placeholder="Task"></joi-input>
            </div>
          </div>
          <task-status-dropdown [task]="task"></task-status-dropdown>
          <div class="tray">
            <div class="comment-holder comments" *ngIf="task.comments?.length">
              <icon [class]="!task.comments || !task.comments.length ? 'commentless' : 'commentful'"  icon="chat_24px"></icon>
              <div *ngIf="unseenCommentsByTask[task.id]" class="chat_dot"></div> 
            </div>
<!--             <div class="comments" >
              <icon icon="comment_18px"></icon>
              <div *ngIf="task.comments.length > task.commentBookmarks" class="new"></div>
            </div> -->
            <div class="duedate" [ngClass]="{ overdue: date && now_time > date }" *ngIf="task.dueDate">
              <icon matIcon="event_available"></icon>
              Due: {{ (task.dueDate?.seconds ? task.dueDate?.seconds * 1000 : task.dueDate) | date: "EEE d MMM" }}
            </div>
            <div class="labels detailed">
              <div class="detailed_label" *ngFor="let obj of task.labels" [ngStyle]="{ background: task_labels[obj]?.color, border: '1px solid ' + task_labels[obj]?.color }">
                {{ task_labels[obj]?.label }}
              </div>
            </div>
            <div class="labels condensed">
              <div class="condensed_label" *ngFor="let lbl of task.condensedLabels; last as last; index as idx" [ngClass]="{ last: last }" [ngStyle]="{ zIndex: 5 - idx, border: '1px solid ' + task_labels[lbl]?.color, backgroundColor: task.labels?.length < 5 || idx < 3 ? task_labels[lbl]?.color : ''}">
                <icon *ngIf="task.labels?.length > 4 && idx == 3" matIcon="more_horiz"></icon>
              </div>
            </div>
            <div *ngIf="task.responsibility as responsible">
              <div class="responsibility" *ngIf="workersByEmail[responsible]">
                <photo [data]="workersByEmail[responsible]"></photo>
                <div class="name">
                  {{ workersByEmail[responsible].firstName }}
                  {{ workersByEmail[responsible].lastName }}
                </div>
              </div>
            </div>
            <div class="subtask_summary" *ngIf="task.subtasks?.length > 0">
              <icon matIcon="check_box"></icon>
              <span>{{ task.subtasksCompleted || 0 }}/{{ task.subtasks?.length }}</span>
            </div>
          </div>
          <div class="desc" [innerHTML]="helpers.strWithBreak(task.content)" *ngIf="task.content"></div>
        </div>
        <div class="platter" [ngClass]="{ readonly: readonly }">
          <div class="plate"></div>
          <icon matIcon="edit"></icon>
        </div>
      </div>
      <div class="subtask_content" *ngIf="task.subtasks?.length > 0">
        <div class="title">
          Subtasks
          <span>({{ task.subtasksCompleted || 0 }}/{{ task.subtasks?.length }})</span>
        </div>
        <div class="subtasks_area unicorn-dark-theme">
          <ng-container *ngFor="let subtask_id of task.subtasks; trackBy: trackByFn">
            <div class="subtask" *ngIf="task.subtasks_obj[subtask_id] as subtask" [ngClass]="{ completed: subtask.completed }">
              <div class="handle"></div>
              <div class="subtask_area">
                <icon (click)="readonly ? null : updateSubtaskCompleted($event, task, subtask)" class="subtask-check-circle" [icon]="subtask.completed ?  'TASKCOMPLETE18' : 'TASKINCOMPLETE18'"></icon>
                <div class="subtask_name" [ngClass]="{ completed: subtask.completed }">
                  {{ subtask.name }}
                </div>
              </div>
            </div>
          </ng-container>
          
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="task-list-container" [ngClass]="{ condensed: condensedView, is_loading: !!tasksLoading || !!prefsLoading }">
  <div class="task-list task-scrollable-fullscreen" 
  #tasksEl><!-- [dragula]="placement + '-tasks-bag'" [(dragulaModel)]="filteredTasks"  -->
  
    <div class="task" #task_el [id]="task.id" *ngFor="let task of filteredTasks; index as idx; trackBy: trackById; last as last" [ngClass]="{ condensed: condensedView, unseen: !task.seen || !task.seen[userService.uid], seenToggled: seenToggled[task.id], completed: task.status === 'complete', last: last, sortByDate: sortByDate }">
      <ng-container *ngTemplateOutlet="taskTemplate; context: { $implicit: task, idx: idx, show_headers: sortByDate, date: task.date }"></ng-container>
    </div>
  </div>
  <div class="controls" [ngClass]="{ is_zoomed: uiService.zoom_mulitplier !== 1 && placement !== 'sidebar' }" *ngIf="!readonly && placement !== 'my_tasks'">
    <div class="buttons">
      <div *ngIf="!show_new_task_input">
        <button class="secondary" (click)="newTaskReady()">
          + Add a task
        </button>
      </div>
      <div class="input_view" *ngIf="show_new_task_input">
        <mat-form-field class="general">
          <textarea matInput cdkTextareaAutosize #taskNameEl [(ngModel)]="new_task_name" placeholder="Task" maxlength="256" (keydown.enter)="addTask($event)"></textarea>
          <mat-hint align="end">{{ new_task_name.length }}/256</mat-hint>
        </mat-form-field>
        <div class="more">
          <!-- WAS <div class="more" *ngIf="!addExtraView">, but there is no addExtraView-->
          <button class="secondary" (click)="popupNewTask()">
            + Add more detail
          </button>
        </div>
        <div class="act">
          <button mat-button color="primary" [disabled]="!new_task_name || !!tasksLoading" (click)="addTask()">
            Add Task
          </button>
          <button mat-button (click)="reset()">Cancel</button>
        </div>
      </div>
    </div>
    <div class="empty" *ngIf="filteredTasks.length === 0 && !tasksLoading">
      <div class="null_state">
        <div class="title">No tasks!</div>
        <p>Keep track of your to-do list by creating tasks and assigning them to people in your&nbsp;workforce.</p>
        <p>Tasks are visible to program & logistics team members unless you specify otherwise.</p>
      </div>
    </div>
  </div>
</div>